import React from 'react';

// TODO RCH : not used for the moment
export default class LocalityHeaderGroup extends React.Component {

    locateBrowser = () => {
        navigator.geolocation.getCurrentPosition(function (position) {
            //The user's browser accepted to share its geolocation
            // eslint-disable-next-line
            var geolocation = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            };
        }, function () {

        });
    };

    render = () => (
        <button type="button" className="mywort-action-group__btn mywort-btn mywort-btn--invert" onClick={this.locateBrowser}>
            <i className="iw-location-arrow"/>
        </button>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/LocalityHeaderGroup.jsx